// src/firebaseConfig.js

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBHfeJCApJlCEaw-mYENpCthZRIKYPiPJ0",
  authDomain: "vale-tts.firebaseapp.com",
  projectId: "vale-tts",
  storageBucket: "vale-tts.firebasestorage.app",
  messagingSenderId: "344583962305",
  appId: "1:344583962305:web:4a54c62e4a7ae526691e40"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

